import chroma from 'chroma-js';

const PLACEHOLDER_VALUES = new Set([
  'example_string',
  'example',
  'string',
  'test',
  'value',
]);

/**
 * Normalize and validate a hex color string for WebMCP tool inputs.
 */
export const normalizeHex = (color: string): string => {
  const trimmed = color.trim();

  if (PLACEHOLDER_VALUES.has(trimmed.toLowerCase())) {
    throw new Error(
      `Invalid hex color: "${color}". Replace inspector placeholders with a 6-digit hex color (e.g. #333333).`
    );
  }

  const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;

  try {
    return (chroma(withHash) as unknown as chroma.Color).hex().toUpperCase();
  } catch {
    throw new Error(
      `Invalid hex color: "${color}". Expected a 6-digit hex color such as #333333 or 2563EB.`
    );
  }
};
